<template>
    <component :is="tag" style="height: 100%">
        <slot
            :brief="brief"
            :contact="contact"
            :task="task"
            :deliverable="deliverable"
            :is-loading="isLoading"
            :error-message="errorMessage"
            :deliver-story-url="deliverStoryUrl"
            :deliver-insights-url="deliverInsightsUrl"
            :upload-headers="uploadHeaders"
            :is-deliverable-complete="isDeliverableComplete"
            :deliverable-has-insights="deliverableHasInsights"
            :handle-story-file-change="handleStoryFileChange"
            :handle-insights-file-change="handleInsightsFileChange"
            :handle-start-connection="handleStartConnection"
            :has-uploaded-files="hasUploadedFiles"
            :uploaded-files="uploadedFiles"
            :task-content="taskContent"
            :is-task-content-loading="isTaskContentLoading"
            :quantity-string="quantityString(task)"
        />
    </component>
</template>

<script>
    import { get } from 'lodash';
    import { message } from '@grininc/grin-ui';
    import ContactsMixin from '../mixins/ContactsMixin';
    import UploadMixin from '../mixins/UploadMixin';
    import BaseActivationBriefStepMixin from '../mixins/BaseActivationBriefStepMixin';
    import ActivationBriefNetworkConnectionSourceMixin from '../mixins/ActivationBriefNetworkConnectionSourceMixin';
    import ActivationTasksMixin from '../../../components/data-views/activation-briefs/mixins/ActivationTasksMixin';
    import ActivationBriefTasksMixin from '../mixins/ActivationBriefTasksMixin';
    import { NAME_TASKS } from '../../../constants/activation-brief-steps';
    import useActivationBriefs from '../../../../src/composables/use-activation-briefs';
    import useFeatureFlagsStore from '../../../../stores/feature-flags';

    export default {
        name: 'ActivationBriefTaskDeliveryInstagramStoryProvider',
        mixins: [
            ContactsMixin,
            BaseActivationBriefStepMixin,
            UploadMixin,
            ActivationBriefNetworkConnectionSourceMixin,
            ActivationBriefTasksMixin,
            ActivationTasksMixin
        ],
        computed: {
            step() {
                return this.steps[NAME_TASKS];
            },
            taskId() {
                return get(this, 'task.id');
            },
            deliverableId() {
                return get(this, 'deliverable.id');
            },
            contactId() {
                return get(this, 'contact.id');
            },
            deliverStoryUrl() {
                if (this.taskRequiresApproval && this.deliverableParamId) {
                    return `/activation-briefs/${this.briefParamId}/deliverables/${this.deliverableParamId}/deliver/story`;
                }
                return `/activation-briefs/${this.briefParamId}/tasks/${this.taskId}/deliver/story`;
            },
            deliverInsightsUrl() {
                return `/activation-briefs/${this.briefParamId}/tasks/${this.taskId}/deliver/story/insights`;
            }
        },
        methods: {
            handleStoryFileChange(info) {
                const { getActivationBriefs } = useActivationBriefs();
                const featureFlags = useFeatureFlagsStore().data;

                if (!featureFlags['task-delivery-improvements-enabled']) {
                    this.handleUploadChange(info, () => {
                        this.loadActivationBrief(true).then(() =>
                            message.success('Nice! Your task has been delivered')
                        );
                    });
                } else {
                    this.handleUploadChange(info, async () => {
                        try {
                            const res = await Promise.all([
                                this.loadActivationBrief(true),
                                getActivationBriefs(this.contactId)
                            ]);
                            this.$root.briefs = res[1].data;
                            this.loadActivationTaskContent();
                            message.success('Nice! Your task has been delivered');
                        } catch (error) {
                            message.error('Something went wrong, please try again.');
                        }
                    });
                }
            },
            handleInsightsFileChange(info) {
                this.handleUploadChange(
                    info,
                    () => {},
                    () => {},
                    true
                );
            }
        },
        created() {
            this.isLoading = true;

            this.loadContact()
                .then(() => {
                    return Promise.all([this.loadActivationBrief(true)]);
                })
                .then(() => {
                    this.initStep(this.step);
                })
                .catch((error) => this.handleHttpError(error))
                .then(() => {
                    this.isLoading = false;
                });

            this.loadActivationTaskContent();
        }
    };
</script>
